// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5027995b","796":"9746530e"}[chunkId] + ".chunk.js";
};